<mat-toolbar class="matero-toolbar header-toolbar">
  <app-branding class="branding header-branding"></app-branding>

  @if ({ length: (menuItems$ | async)?.length }; as menuItems) {
    <!-- big top nav bar -->
    @if (showMenuItems) {
      <app-topmenu
        class="header-topmenu"
        [class.is-hidden]="menuItems.length >= menuLengthMax"
      ></app-topmenu>
    }
    <div
      class="header-useractions"
      [class.is-hidden]="!showUserMenuItems || menuItems.length >= menuLengthMax"
    >
      <user-actions></user-actions>
    </div>
    <!-- small sidenav toggle -->
    <div class="header-spacer" [class.is-hidden]="menuItems.length < menuLengthMax"></div>
    @if (helpService.currentHelpId) {
      <button mat-button (click)="openHelp()"><mat-icon>help</mat-icon></button>
    }
    @if (showToggle) {
      <button
        [class.header-hide-gt-md]="menuItems.length < menuLengthMax"
        mat-button
        (click)="toggleSidenav.emit()"
      >
        <mat-icon>menu</mat-icon>
      </button>
    }
  }
</mat-toolbar>
